"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var accesoriesStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var spacing = _a.spacing, breakpoints = _a.breakpoints, palette = _a.palette;
    return ({
        root: {
            margin: spacing(2) + " 0",
        },
        grid: (_b = {
                margin: '10px 0',
                flexDirection: 'row-reverse'
            },
            _b[breakpoints.down('sm')] = {
                margin: 0,
            },
            _b),
        image: {
            maxWidth: '100%',
        },
        container: {
            display: 'flex',
            padding: "0 " + spacing(2),
            flexDirection: 'column',
        },
        checkIcon: {
            color: 'green',
            marginRight: spacing(0.5),
        },
        title: {
            margin: spacing(1) + " 0",
            display: 'flex',
            alignItems: 'center',
        },
        button: {
            marginBottom: spacing(1),
        },
        primaryButton: {},
        primaryButtonCaption: {
            color: palette.common.white,
        },
        secondaryButtonCaption: {
            color: palette.primary.main,
        },
        header: {
            marginLeft: spacing(3),
        },
        textContent: {
            marginBottom: spacing(2),
        },
        continueButtonContainer: {
            paddingTop: 20,
        },
    });
}, { name: 'Checkout4_Accesories' });
exports.default = accesoriesStyles;
